// src/pages/AnexarPDF.js

import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import AnexoPDF from '../components/AnexoPDF';

const AnexarPDF = () => {
    return (
        <>
            <div className="main-content">
                <Navbar />
            </div>
            <div className="content">
                <Sidebar />
            </div>
            <div className='attachment'>
                <AnexoPDF />
            </div>
        </>
    );
};

export default AnexarPDF;
